var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatriaLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 107,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 531 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_25"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "svg_1",
    points: "23.600000381469727,88.19999885559082 30.899999618530273,75.40000343322754 16.200000762939453,75.40000343322754 23.600000381469727,62.700002670288086 1.5,62.700002670288086 12.399999618530273,43.700002670288086 23.600000381469727,43.700002670288086 16.200000762939453,30.900001525878906 31,30.900001525878906 23.600000381469727,18.10000228881836 63.900001525878906,18.10000228881836 56.5,30.900001525878906 71.30000305175781,30.900001525878906 63.900001525878906,43.700002670288086 75,43.700002670288086 86.0999984741211,62.700002670288086 63.900001525878906,62.700002670288086 71.30000305175781,75.40000343322754 56.5,75.40000343322754 63.900001525878906,88.19999885559082 ",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_2",
    points: "43.70000076293945,59.60000038146973 51.099998474121094,72.30000495910645 58.5,85.10000038146973 43.70000076293945,85.10000038146973 29,85.10000038146973 36.400001525878906,72.30000495910645 ",
    fill: "#911F89"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_3",
    points: "43.70000076293945,46.80000114440918 36.400001525878906,34.00000190734863 29,21.30000114440918 43.70000076293945,21.30000114440918 58.5,21.30000114440918 51.099998474121094,34.00000190734863 ",
    fill: "#EABD26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_4",
    points: "58.5,46.80000114440918 43.70000076293945,46.80000114440918 51.099998474121094,34.00000190734863 65.80000305175781,34.00000190734863 ",
    fill: "#6EAD3B"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_5",
    points: "36.400001525878906,59.60000038146973 6.900000095367432,59.60000038146973 14.199999809265137,46.80000114440918 43.70000076293945,46.80000114440918 ",
    fill: "#C22821"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_6",
    points: "29,46.80000114440918 43.70000076293945,46.80000114440918 36.400001525878906,34.00000190734863 21.600000381469727,34.00000190734863 ",
    fill: "#E76727"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_7",
    points: "51.099998474121094,59.60000038146973 80.5999984741211,59.60000038146973 73.19999694824219,46.80000114440918 43.70000076293945,46.80000114440918 ",
    fill: "#009479"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_8",
    points: "29,59.60000038146973 43.70000076293945,59.60000038146973 36.400001525878906,72.30000495910645 21.600000381469727,72.30000495910645 ",
    fill: "#C84378"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_9",
    points: "58.5,59.60000038146973 43.70000076293945,59.60000038146973 51.099998474121094,72.30000495910645 65.80000305175781,72.30000495910645 ",
    fill: "#0081C6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_10",
    points: "58.5,46.80000114440918 43.79999923706055,46.80000114440918 29,46.80000114440918 21.700000762939453,59.60000038146973 43.79999923706055,59.60000038146973 65.9000015258789,59.60000038146973 ",
    fill: "#001C85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_11",
    points: "51.20000076293945,34.00000190734863 43.79999923706055,34.00000190734863 36.400001525878906,34.00000190734863 40.099998474121094,40.40000343322754 43.79999923706055,46.80000114440918 47.5,40.40000343322754 ",
    fill: "#001C85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_12",
    points: "36.400001525878906,72.30000495910645 51.20000076293945,72.30000495910645 43.79999923706055,59.60000038146973 ",
    fill: "#001C85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    d: "m128.4,81.5c1.8,6.6 -1.6,12.4 -11.6,13.5c0,0 -0.1,0 -0.1,0c0,0 0,0 -0.1,0l0,0c-1.2,0.1 -2.4,0.2 -3.6,0.2l-9.3,0l-11.5,0l0,-38.2l19,0l1.8,0c8.3,0 12.8,3.8 12.2,10.9c0,0 -0.8,6.1 -7.2,7c5.1,0.8 6.9,2.3 6.9,2.3l0,0c1.6,1 2.9,2.3 3.5,4.3m-21.4,-19.2l-3.4,0l0,11.1l4.4,0c0.2,0 0.3,0 0.5,0c5.9,-0.5 5.7,-5.9 5.7,-5.9c-0.1,-3.8 -2.7,-5.2 -7.2,-5.2m-3.4,27.7l1.2,0l5.3,0c0,0 6,0.3 6.4,-4.9c0,-0.2 0,-0.4 0,-0.7c0,-0.7 -0.1,-1.3 -0.3,-1.9c-1.4,-4.4 -8,-4.3 -8,-4.3l-4.7,0l0,11.8l0.1,0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    d: "m159.5,57l16.2,38.3l-12.2,0l-4,-9.3l-17.5,0l-4.3,9.3l-8.5,0l17.5,-38.3l12.8,0zm-2.6,22.9l-4.3,-10c-0.5,-1.7 -1.1,-3.4 -1.3,-4.6l-0.1,0c-0.4,1.6 -1.1,3 -1.7,4.6l-4.6,10l12,0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    d: "m207.8,75.6c0,1.2 0.1,3.4 0.1,4.6l-0.1,0c-0.3,-1 -1.4,-3 -2.4,-4.4l-13.1,-18.8l-12.2,0l0,38.3l8.5,0l0,-21.1c0,-1.3 -0.1,-3.1 -0.1,-4l0.1,0c0.4,0.9 1.1,2.4 2,3.6l15.7,21.5l10.1,0l0,-38.3l-8.5,0l0,18.6l-0.1,0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    d: "m226.5,95.3l11.5,0l0,-38.3l-11.5,0l0,38.3z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    d: "m263.5,57l-10.7,0l-14.1,18.3l14.8,20l13.4,0l-16.7,-21.8l13.3,-16.5z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    id: "svg_13",
    d: "m103.69999,16.3l3.4,0c4.5,0 8.2,1.6 8.2,6.5c0,4.3 -3.2,7 -8,7l-2.3,0l4.1,5.7c4.6,0.7 18.3,-1.5 18.1,-12.9c-0.1,-7 -5.9,-11.5 -14.2,-11.5l-20.8,0l0,38.3l11.5,0l0,-33.1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    d: "m165.59999,17.6l14.4,0l0,31.7l11.4,0l0,-31.7l14.2,0l0,-6.6l-40,0l0,6.6z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    d: "m170.49999,49.3l-12.2,0l-4,-9.3l-17.5,0l-4.3,9.4l-8.5,0l17.5,-38.4l12.8,0l16.2,38.3zm-18.9,-15.4l-4.3,-10c-0.5,-1.7 -1.1,-3.4 -1.4,-4.6l-0.1,0c-0.4,1.6 -1.1,3 -1.7,4.6l-4.6,10l12.1,0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    d: "m237.39999,32.1l0,0c4.2,-1.2 8.5,-4.6 8.5,-10.9c0,-7 -5.9,-10.2 -14.2,-10.2l-21.1,0l0,38.3l11.5,0l0,-33l4.2,0c4.5,0 7.8,1.6 7.8,6.5c0,4.3 -2.7,7 -7.6,7l-2.8,0l14.1,19.5l12.9,0c0,0 -10,-13.6 -10.6,-14.4c-0.6,-0.8 -2.4,-2.5 -2.7,-2.8",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    d: "m255.39999,49.3l11.5,0l0,-38.3l-11.5,0l0,38.3zm46.6,-38.3l16.2,38.3l-12.2,0l-4,-9.3l-17.5,0l-4.3,9.3l-8.5,0l17.5,-38.3l12.8,0zm-2.6,22.9l-4.3,-10c-0.5,-1.7 -1.1,-3.4 -1.3,-4.6l-0.1,0c-0.4,1.6 -1.1,3 -1.7,4.6l-4.6,10l12,0z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatriaLogoWhite);
export default __webpack_public_path__ + "static/media/patria_logo_white.2c42e199f813c47705acfeb2d271c9d6.svg";
export { ForwardRef as ReactComponent };